import { ModuleRatingsScreen } from "./module-ratings.screen";
import { PrivateRouteDefinition } from "../../../infecto-lms-admin/components/core/model/PrivateRouteDefinition";

export const MODULE_RATINGS_PATH = "/module-ratings";
export const ModuleRatingsRoutes: PrivateRouteDefinition[] = [
	{ element: <ModuleRatingsScreen />, path: MODULE_RATINGS_PATH, requiredPermissions: [] },
];
